export enum DiffChangeType {
  Field = 'field',
  ArrayItemAdded = 'array-item-added',
  ArrayItemRemoved = 'array-item-removed',
  ArrayItemModified = 'array-item-modified',
}